import {
  MrSearchConfig,
  MrSearchFacetsConfig,
  MrSearchLayoutInput,
} from '@net7/boilerplate-muruca';

const facets = {
  sections: [
     {
      id: 'section-places',
      header: {
        id: 'header-places',
        data: {
          text: 'search#header_places',
          additionalText: null
        }
      },
      inputs: [{
        id: 'places',
        type: 'map',
        limit: 500,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: false,
        },
        initialize: true,
        libOptions: {
          center: [42.00, 65.00],
          zoom: 4,
          minZoom: 2,
          // maxZoom: 8,
          iconSize: [13, 20],
          maxClusterRadius: 5,
          disableClusteringAtZoom:3,
          layerUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      }],
    },
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_query_general',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-query_name',
      inputs: [
        {
          id: 'query_name',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query_name',
            placeholder: 'search#placeholder_query-name',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-place_name',
      header: {
        id: 'header-place_name',
        data: {
          text: 'search#header_place_name',
          additionalText: null
        }
      },
      inputs: [
        {
          type: 'text',
          id: 'query-place_name',
          target: 'place_name',
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-editore',
            placeholder: 'search#placeholder_place_name',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
        {
          id: 'place_name',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true
          },
          data: {
            links: []
          }
        }
      ]
    },
    {
      id: 'section-years',
      header: {
        id: 'header-years',
        data: {
          text: 'search#header_years',
          additionalText: null
        }
      },
      inputs: [{
        id: 'years',
        type: 'histogram',
        limit: 500,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: false,
        }
      }],
    },
    {
      id: 'section-query_years',
      inputs: [
        {
          id: 'query_years',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query_years',
            type: 'number',
            min: 0,
            placeholder: 'search#placeholder_query_years',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-sex',
      header: {
        id: 'header-sex',
        data: {
          text: 'search#header_sex',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'sex',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-profession',
      header: {
        id: 'header-profession',
        data: {
          text: 'search#header_profession',
          additionalText: null
        }
      },
      inputs: [
        // {
        //   type: 'text',
        //   id: 'query-profession',
        //   target: 'profession',
        //   delay: 500,
        //   schema: {
        //     valueType: 'string',
        //   },
        //   data: {
        //     id: 'query-profession',
        //     placeholder: 'search#placeholder_profession',
        //     icon: 'n7-icon-search',
        //     inputPayload: 'search-input',
        //     enterPayload: 'search-enter',
        //     iconPayload: 'search-icon',
        //   },
        // },
        {
          id: 'profession',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true
          },
          data: {
            links: []
          }
        }
      ]
    },
    {
      id: 'section-query_profession_specific',
      inputs: [
        {
          id: 'query_profession_specific',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query_profession_specific',
            placeholder: 'search#placeholder_profession_specific',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    // {
    //   id: 'section-profession',
    //   header: {
    //     id: 'header-profession',
    //     data: {
    //       text: 'search#header_profession',
    //       additionalText: null,
    //     },
    //   },
    //   inputs: [
    //     {
    //       id: 'profession',
    //       type: 'link',
    //       limit: 50,
    //       queryParam: true,
    //       schema: {
    //         valueType: 'string',
    //         multiple: true,
    //       },
    //       data: {
    //         links: [],
    //       },
    //     },
    //   ],
    // },
    {
      id: 'section-institution',
      header: {
        id: 'header-institution',
        data: {
          text: 'search#header_institution',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'institution',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-events',
      header: {
        id: 'header-events',
        data: {
          text: 'search#header_events',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'events',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
  ],
  classes: 'facets-wrapper',
} as MrSearchFacetsConfig;

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
})) as MrSearchLayoutInput[];

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
